import styled, { keyframes } from 'styled-components';
import { TStatusTone } from '../../../utils/tournament/status';
import { softTone } from '../tones';
import { textSize } from '../../../styles/brand';

const ping = keyframes`
  from { transform: scale(0.5); opacity: 0.9; }
  to { transform: scale(1.8); opacity: 0; }
`;

export const Pill = styled.span<{ $tone: TStatusTone; $size: 'sm' | 'md' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: fit-content;
  white-space: nowrap;
  border-radius: 999px;
  font-family: 'RedHatDisplay-Bold';
  padding: ${({ $size }) =>
    $size === 'sm' ? '0.15rem 0.55rem' : '0.25rem 0.75rem'};
  font-size: ${({ $size }) => textSize($size === 'sm' ? 0.72 : 0.8)};
  line-height: 1.3;
  ${({ $tone }) => softTone($tone)}

  svg {
    width: 1em;
    height: 1em;
    flex: none;
  }
`;

export const LiveDot = styled.span`
  position: relative;
  width: 0.45em;
  height: 0.45em;
  flex: none;
  border-radius: 50%;
  background: currentColor;

  &::after {
    content: '';
    position: absolute;
    inset: -0.25em;
    border-radius: 50%;
    border: 1.5px solid currentColor;
    animation: ${ping} 1.6s ease-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
      opacity: 0.4;
    }
  }
`;
